<template>
    <v-sheet>
      <v-form v-model="valid">
        <v-row>
            <v-col
                cols="12"
                md="6"
            >
                <v-textarea prepend-icon="mdi-presentation" required :rules="topicRules" v-model="topic" :label="this.$t('topic_label')" :placeholder="this.$t('topic_placeholder')"></v-textarea>
                <v-text-field prepend-icon="mdi-human" required :rules="participantsNumberRules" v-model="participantsNumber" :label="this.$t('participants_number_label')" :placeholder="this.$t('participants_number_placeholder')"></v-text-field>
                <v-menu
                    v-model="calendarMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="expectedDate"
                            :label="expedtedDateLabel"
                            :rules="expectedDateRules"
                            persistent-hint
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                            required
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="expectedDate"
                        no-title
                        @input="calendarMenu = false"
                    ></v-date-picker>
                </v-menu>
                <v-text-field prepend-icon="mdi-map-marker" required :rules="expectedPlaceRules" v-model="expectedPlace" :label="this.$t('expected_place_label')" :placeholder="this.$t('expected_place_placeholder')"></v-text-field>
            </v-col>
            <v-col
                cols="12"
                md="6"
            >
                <v-text-field prepend-icon="mdi-domain" required :rules="companyRules" v-model="companyName" :label="this.$t('company_label')" :placeholder="this.$t('company_placeholder')"></v-text-field>
                <v-text-field prepend-icon="mdi-mail" required :rules="emailRules" v-model="mail" :label="this.$t('email_label')" :placeholder="this.$t('email_placeholder')"></v-text-field>
                <v-text-field prepend-icon="mdi-phone" required :rules="phoneNumberRules" v-model="phoneNumber" :label="this.$t('phone_label')" :placeholder="this.$t('phone_placeholder')"></v-text-field>
                <v-textarea prepend-icon="mdi-comment-text" v-model="additionalRemarks" :label="this.$t('additional_remarks_label')" :placeholder="this.$t('additional_remarks_placeholder')"></v-textarea>
                <v-checkbox v-model="proceedPesonalDataCheckbox" :rules="proceedPesonalDataRules" :label="this.$t('allow_to_process_personal_data')"></v-checkbox>
            </v-col>
        </v-row>
        <v-btn :disabled="!valid" block @click="handleSubmitForm">{{$t('submit')}}</v-btn>
        <v-snackbar
            v-model="sendedMail"
            color="green"
            rounded="pill"
            >
            {{ $t('sended_mail') }}

            <template v-slot:action="{ attrs }">
                <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="sendedMail = false"
                >
                {{$t('close')}}
                </v-btn>
            </template>
        </v-snackbar>
      </v-form>
    </v-sheet>
  </template>
  
  <script>
  import axios from "axios";
  import config from "@/config"
  


  export default {

    props: {
        type: {
            type: String,
            default: "closed"
        },
    },
  
    methods: {
      handleSubmitForm() {
        let message = `\
        Typ szkolenia: ${this.type === "opened" ? "otwarte" : "zamknięte"} <br />\
        Temat: ${this.topic} <br />\
        Liczba uczestników: ${this.participantsNumber} <br />\
        Przewidywana data: ${this.expectedDate} <br />\
        Przewidywane miejsce: ${this.expectedPlace} <br />\
        Nazwa instytucji/firmy: ${this.companyName} <br />\
        Adres email: ${this.email} <br />\
        Numer telefonu: ${this.phoneNumber} <br />\
        Uwagi: ${this.additionalRemarks}`;
        let postData = {
          template: 'contact',
          title: "Pytanie o szkolenie",
          topic: "Pytanie o szkolenie",
          message: {message: message, mail: this.mail}
        }
        axios.post(config.MAIL_API_URL, postData)
            .then(response => console.debug('response', response))
            .then(this.sendedMail = true);
      }
    },

    computed: {
        expedtedDateLabel() {
            return this.$t('expected_date_label');
        },
    },
  
    data() {
      return {
        valid: false,
        calendarMenu: false,
        emailRules: [
          v => !!v || this.$t('email_required'),
          v => /.+@.+/.test(v) || this.$t('email_not_valid'),
        ],
        nonEmptyRules: [
          v => !!v || this.$t('field_required')
        ],
        nameSurnameRules: [
            v => !!v || this.$t('name_surname_required'),
        ],
        phoneNumberRules: [
            v => !!v || this.$t('phone_required'),
        ],
        participantsNumberRules: [
            v => !isNaN(v) || this.$t('field_not_nan'),
            v => !!v || this.$t('field_required'),
        ],
        topicRules: [
            v => !!v || this.$t('field_required')
        ],
        companyRules: [
            v => !!v || this.$t('field_required')
        ],
        expectedDateRules: [
            v => !!v || this.$t('field_required')
        ],
        expectedPlaceRules: [
            v => !!v || this.$t('field_required')
        ],
        proceedPesonalDataRules: [
            v => !!v || this.$t('check_field')
        ],
        topic: '',
        participantsNumber: 5,
        expectedDate: null,
        expectedPlace: '',
        mail: '',
        phoneNumber: '',
        companyName: '',
        additionalRemarks: '',
        proceedPesonalDataCheckbox: false,
        sendedMail: false,
      }
    },
  
  }
  </script>
  